import * as process from 'process';
import { useEffect, useState } from 'react';
import { contract } from '@aviv_price-pages/brand';
import MapboxLanguageControl from '@mapbox/mapbox-gl-language';
import { Map } from 'mapbox-gl';
import { MAP_DEFAULT_STYLE, MAP_MAX_ZOOM_INTERACTION, MAP_MIN_ZOOM_INTERACTION } from '@/constants';
import { transformRequest as transformRequestHelper } from '@/helpers/map/mapboxTransformRequest';
/**
 * Hook that initialize and get access to the Mapbox map instance
 * @param {MapboxConfig} config - The mapbox config
 * @returns The map instance or undefined
 */
export const useMapbox = ({ container, locale = contract.i18n.defaultLocale, transformRequest = transformRequestHelper(process.env.PRICE_TILE_API_URL, process.env.PRICE_TILE_API_KEY, process.env.TILE_API_URL, process.env.GEO_SERVICE_APIKEY), minZoom = MAP_MIN_ZOOM_INTERACTION, maxZoom = MAP_MAX_ZOOM_INTERACTION, accessToken = process.env.MAPBOX_TOKEN, style = MAP_DEFAULT_STYLE, defaultBounds, }) => {
    const [map, setMap] = useState();
    useEffect(() => {
        if (!container.current) {
            return;
        }
        if (map) {
            return;
        }
        const mapInstance = new Map({
            minZoom,
            maxZoom,
            touchPitch: false,
            dragRotate: false,
            pitchWithRotate: false,
            accessToken,
            container: container.current,
            style,
            transformRequest,
            bounds: defaultBounds,
        });
        const mapboxLanguageControl = new MapboxLanguageControl({
            defaultLanguage: locale,
        });
        mapInstance?.addControl(mapboxLanguageControl);
        if (mapInstance.touchZoomRotate) {
            mapInstance.touchZoomRotate.disableRotation();
        }
        setMap(mapInstance);
    }, [
        map,
        container,
        accessToken,
        style,
        locale,
        transformRequest,
        defaultBounds,
        minZoom,
        maxZoom,
    ]);
    return map;
};
